module.exports = __webpack_public_path__ + "img/wandian.1bf5e392.svg";